import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import AnnouncementList from './components/AnnouncementList';

const { Cell } = ResponsiveGrid;

const Announcement = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="公告事項列表"
        breadcrumbs={[
          {
            name: '公告事項',
          },
          {
            name: '公告事項列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <AnnouncementList />
    </Cell>
  </ResponsiveGrid>
);

export default Announcement;
